import React from 'react';
import _epCarousel from "./enginParts/_epCarousel";
import _epBanner from "./enginParts/_epBanner";
import _epTitr6 from "./enginParts/_epTitr6";

const HomeEngine = ({items}) => {
    const enginSw = (i) => {
        switch (i.Type){
            case "CAROUSEL":return _epCarousel(i);
            case "BANNER":return _epBanner(i);
            case "TITR6":return _epTitr6(i);
        }
    }


    return items.map(i=>enginSw(i))
};

export default HomeEngine;
